export default __webpack_public_path__ + "static/media/sota-watanabe.fe8d5362.jpeg";